<script>
  import { onMount } from 'svelte';
  import { domainName, record, modifyRecord, recordCreated, newRecordCreated } from '../stores.js';
  import { makeSymbolicName } from '../util.js';
  import { dmarcCreate } from '../api.js';
  // import { thankYouMessageDMARC } from '../constants.js';

  const { Drupal } = window;

  let loading = false;
  let recordModify = {...$record};

  onMount(() => {
    // Attach Bootstrap popover.
    Drupal.behaviors.popover.attach();
    const collapseElementList = document.querySelectorAll('.collapse');
    const collapseList = [...collapseElementList].map(collapseEl => new bootstrap.Collapse(collapseEl, {
      toggle: false
    }));

    $modifyRecord.p = recordModify.dmarc.policy;

    if (recordModify.dmarc.rua) {
      let create_rua = recordModify.dmarc.rua;
      $modifyRecord.rua = create_rua[0].replace('mailto:', '');
    }
    if (recordModify.dmarc.ruf) {
      let create_ruf = recordModify.dmarc.ruf;
      $modifyRecord.ruf = create_ruf[0].replace('mailto:', '');
    }

    $modifyRecord.domain_name = $domainName;
    $modifyRecord.agari_rua = makeSymbolicName($domainName) + '@rua.agari.com';
    $modifyRecord.agari_ruf = makeSymbolicName($domainName) + '@ruf.agari.com';
  });

  function createDmarc() {
    loading = true;
    $recordCreated = dmarcCreate($modifyRecord);
    $newRecordCreated = true;
  };

</script>

<!-- Form -->
<div class="form-box">
  <div class="mb3">
    <h6 class="font-weight-bold">Fill out this form to create or modify a DMARC record.</h6>
    <em>All fields marked * are required.</em>
  </div>

  <div class="ag-tool__create-form">
    <form data-event="tools | dmarc | modify record" action="/resources/dmarc" method="post" class="ag-tools-form">
      <div class="mb-3">
        <label for="create_domain_name">What domain do you want to create a record for?</label>
        <span class="help-box" data-toggle="popover" data-content="The domain name for which you are creating or modifying a DMARC record. You can enter a single domain or a comma separated list of domain names."></span>
        <input type="text" class="form-control" id="create_domain_name" name="create_domain_name" value="{$domainName}">
      </div>

      <div class="mb-3">
        <label for="create_p">How strict do you want you DMARC policy to be?</label>
        <span class="help-box" data-toggle="popover" data-content="<p>DMARC specifies 3 different possible policy actions to assign to messages which fail DMARC checks. If you are new to publishing a DMARC policy, you should begin with a policy of Monitor only (p=None) so that you can collect and analyze data without affecting your email traffic.</p>
          <ul>
            <li><strong>Monitor only</strong> - (most lenient) Tells receivers to take no special action on failing messages, but send DMARC data to the specified reporting addresses.</li>
            <li><strong>Quarantine</strong> - (more strict) Tells receivers to place messages which fail DMARC into the recipient's spam folder or other quarantined area where the message may be reviewed with suspicion.</li>
            <li><strong>Reject</strong> - (most strict) Tells receivers to reject any messages which fail DMARC and report on the action in DMARC data. Rejected messages will never be available to the recipient.</li>
          </ul>"></span>
        <select bind:value={$modifyRecord.p} class="form-control" id="create_p" name="create_p">
          <option value="none">Monitor only</option>
          <option value="quarantine">Quarantine</option>
          <option value="reject">Reject</option>
        </select>
      </div>

      <div class="mb-3">
        <label for="create_rua">Where do you want Aggregate Reports to be sent? <span class="domain">&bull; {$modifyRecord.agari_ruf} and</span></label>
        <span class="help-box" data-toggle="popover" data-content="<p>Agari's DMARC Builder sets Agari's reporting address by default for both aggregate reports and forensic data. You can specify another address in addition to Agari's address and both will appear in the DMARC record. DMARC receivers should send reporting data to both addresses.</p><p>Caution! Forensic data is a real time flow of messages failing DMARC. Data volumes can be very high and very sporadic. Adding your own reporting address here may cause problems with your local mail server.</p>"></span>
        <input bind:value="{$modifyRecord.rua}" type="text" class="form-control" id="create_rua" name="create_rua">
      </div>

      <div class="mb-3">
        <label for="create_ruf">Where do you want Forensic Data to be sent? <span class="domain">&bull; {$modifyRecord.agari_ruf} and</span></label>
        <input bind:value="{$modifyRecord.ruf}" type="text" class="form-control" id="create_ruf" name="create_ruf">
      </div>
<!--
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="first_name">First Name<span class="req">*</span> (required)</label>
            <input bind:value="{$modifyRecord.firstName}" required type="text" class="form-control" id="first_name" name="first_name">
          </div>
          <div class="col">
            <label for="last_name">Last Name<span class="req">*</span> (required)</label>
            <input bind:value="{$modifyRecord.lastName}" required type="text" class="form-control" id="last_name" name="last_name">
          </div>
        </div>
      </div>

      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="email">Work Email<span class="req">*</span> (required)</label>
            <input bind:value="{$modifyRecord.email}" required type="text" class="form-control" id="email" name="email">
          </div>
          <div class="col">
            <label for="company">Company</label>
            <input bind:value="{$modifyRecord.company}" type="text" class="form-control" id="company" name="company">
          </div>
        </div>
      </div>
-->
      <div class="mb-3">
        <a class="mb-3 collapsed" data-toggle="collapse" href="#collapseAdvanced" role="button" aria-expanded="false" aria-controls="collapseAdvanced">
          Advanced settings
        </a>

        <div class="collapse" id="collapseAdvanced">
          <div class="mb-3">
            <label for="create_rf">Which Report Format option should forensic reports be sent in?</label>
            <span class="help-box" data-toggle="popover" data-content="While the DMARC specification allows both AFRF and IODEF formats for forensic reports, currently the only format sent by DMARC receivers is AFRF."></span>

            <div class="form-check">
              <input bind:group={$modifyRecord.rf} value={'afrf'} class="form-check-input" type="radio" name="create_rf" id="test1">
              <label class="form-check-label" for="test1">AFRF</label>
            </div>
            <div class="form-check">
              <input bind:group={$modifyRecord.rf} value={'iodef'} class="form-check-input" type="radio" name="create_rf" id="test2">
              <label class="form-check-label" for="test2">IODEF</label>
            </div>
          </div>

          <div class="mb-3">
            <label for="create_adkim">Which DKIM Identifier Alignment option should be used?</label>
            <span class="help-box" data-toggle="popover" data-content="Relaxed alignment allows for the DKIM signing domain and header from domain to be sub-domains of each other. Strict alignment requires the two domains be an exact match."></span>

            <div class="form-check">
              <input bind:group={$modifyRecord.adkim} value={'relaxed'} class="form-check-input" type="radio" name="create_adkim" id="test3">
              <label class="form-check-label" for="test1">Relaxed</label>
            </div>
            <div class="form-check">
              <input bind:group={$modifyRecord.adkim} value={'strict'} class="form-check-input" type="radio" name="create_adkim" id="test4">
              <label class="form-check-label" for="test2">Strict</label>
            </div>
          </div>

          <div class="mb-3">
            <label for="create_aspf">Which SPF Identifier Alignment option should be used?</label>
            <span class="help-box" data-toggle="popover" data-content="Relaxed alignment allows for the SPF domain and header from domain to be sub-domains of each other. Strict alignment requires the two domains be an exact match."></span>

            <div class="form-check">
              <input bind:group={$modifyRecord.aspf} value={'relaxed'} class="form-check-input" type="radio" name="create_aspf" id="test3">
              <label class="form-check-label" for="test1">Relaxed</label>
            </div>
            <div class="form-check">
              <input bind:group={$modifyRecord.aspf} value={'strict'} class="form-check-input" type="radio" name="create_aspf" id="test4">
              <label class="form-check-label" for="test2">Strict</label>
            </div>
          </div>

          <div class="mb-3">
            <label for="create_pct">What Percentage of email do you want to apply this policy to?</label>
            <span class="help-box" data-toggle="popover" data-content="The percentage of messages from the domain for which the policy will be applied. For example, if you specify a 'reject' policy and 50%, then the reject policy will only be applied to a random 50% of the messages failing DMARC Authentication by the receiver."></span>
            <div class="input-group">
              <input bind:value={$modifyRecord.pct} type="text" class="form-control" id="create_pct" name="create_pct">
              <span class="input-group-text">% of Policy</span>
            </div>
          </div>

          <div class="mb-3">
            <label for="create_ri">How often should Aggregate Reports be sent?</label>
            <span class="help-box" data-toggle="popover" data-content="While the DMARC specification allows you to request DMARC aggregate reports in different time intervals, in reality all current DMARC implementations only send reports in 24 hour increments."></span>
            <div class="input-group">
              <span class="input-group-text">Every</span>
              <input bind:value={$modifyRecord.ri} type="number" class="form-control" id="create_ri" name="create_ri" min="1">
              <span class="input-group-text">hours</span>
            </div>
          </div>

          <div class="mb-3">
            <label for="create_sp">Do you want a different policy to be applied to sub-domains to be?</label>
            <span class="help-box" data-toggle="popover" data-content="By default, a domain's DMARC policy applies to all of its sub-domains. DMARC allows you to apply a different policy to sub-domains if you wish; however, whichever sub-domain policy you specify will apply to all sub-domains. If you want a different policy for specific sub-domains, publish a DMARC record specifically for that sub-domain."></span>
            <select bind:value={$modifyRecord.sp} class="form-control" id="create_sp" name="create_sp">
              <option value="none" selected>Same as domain</option>
              <option value="none">Monitor only</option>
              <option value="quarantine">Quarantine</option>
              <option value="reject">Reject</option>
            </select>
          </div>

          <div class="mb-3">
            <label for="create_fo">Which Forensic Report option should be used?</label>
            <span class="help-box" data-toggle="popover" data-content="You can instruct DMARC receivers under which failure conditions you would like to receive forensic reports. Agari will set this to send reports for any SPF or DKIM failure by default. You can change this to send reports only if both SPF and DKIM fail."></span>

            <div class="form-check">
              <input bind:group={$modifyRecord.fo} value={1} class="form-check-input" type="radio" name="create_fo" id="test5">
              <label class="form-check-label" for="test1">Send reports for any SPF or DKIM failure</label>
            </div>
            <div class="form-check">
              <input bind:group={$modifyRecord.fo} value={0} class="form-check-input" type="radio" name="create_fo" id="test6">
              <label class="form-check-label" for="test2">Send reports only if both SPF and DKIM fail</label>
            </div>
          </div>
        </div>
      </div>

      <button on:click|preventDefault={createDmarc} class:loading disabled={loading} type="submit" class="btn btn-1">Next</button>
    </form>
  </div>
</div>
<!-- -->
<style>

</style>
